import * as React from 'react';
import i18next from 'i18next';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Formik } from 'formik';

import { BackgroundImage, UserContainer, Title, Form, UserForm, FormFields } from '../../../styles/styled-components/User/User';
import { SubmitButton } from '../../../components/SubmitButton/SubmitButton';

// tslint:disable-next-line: no-any
interface ChangePasswordSuccessProps extends RouteComponentProps<any> {
}
interface States {
  isLoading: boolean;
}
class ChangePasswordSuccess extends React.Component<ChangePasswordSuccessProps, States> {

  state = {
    isLoading: false,
  };
  handleButtonClick() {
    this.props.history.push(`/`);
  }

  render() {
    return (
      <UserContainer>
        <BackgroundImage />
        <UserForm>
          <Formik initialValues={this.state}
            onSubmit={(values, actions) => this.handleButtonClick()}>
            {() => (
              <Form method="POST">
                <Title>{i18next.t('successfulReset.title')}</Title>
                <FormFields>
                  <SubmitButton>
                    {i18next.t('successfulReset.goBackToLogInButton')}

                  </SubmitButton>
                </FormFields>
              </Form>
            )}
          </Formik>
        </UserForm>
      </UserContainer>
    );
  }
}

export default withRouter(ChangePasswordSuccess);